import { Modal } from 'ant-design-vue'

// [2026-10-07] 「点菜单没反应 / 部分页面打不开」兜底
//
// 根因: 覆盖式发版后 chunk 文件名(内容哈希)全部更换; 一直开着的会话(好粮宝桌面版常年
// 不关)内存里还是旧的 chunk 映射表, 首次点开"本会话没打开过"的页面时请求旧 js/css →
// 服务器已无此文件 → import() 以 ChunkLoadError 拒绝 → vue-router 静默中止导航:
// 页签不出现、URL 不变、无任何报错, 用户只能 F5 (未打开过的页面才会中招, 已打开过的
// 走 keep-alive/webpack 模块缓存不重新拉文件, 所以症状是"部分页面打不开")。
//
// 本守卫拦两类信号弹窗引导用户主动刷新; 不自动 reload —— 刷新会清空 keep-alive 页签
// 与未保存的表单, 时机必须由用户决定:
//   1. router.onError —— 路由懒加载组件加载失败(主路径, 覆盖菜单/页签所有导航)
//   2. window error(captrue) —— chunk script/link 资源加载失败, 或 chunk 脚本被
//      index.html 兜底污染成 HTML 后执行报语法错(只认 chunk 路径上的语法错, 业务
//      代码的运行时错不会命中, 防误伤)

const THROTTLE_MS = 10 * 1000

// 构建产物 chunk 路径: publicPath './' → /js/2360.6915a95c.js、/css/xxx.css
const CHUNK_URL_RE = /\/(js|css)\/[\w.-]+\.(js|css)(\?|$)/
// HTML 被当 JS 执行的典型语法错特征(babel 产物不会有语法错, 命中即资源被污染)
const SYNTAX_ERR_RE = /^(Unexpected token|Unexpected end of input|Unexpected identifier|Invalid or unexpected token|Unterminated string)/i

let lastPromptAt = 0

function isChunkLoadError(err) {
  if (!err) return false
  if (err.name === 'ChunkLoadError') return true
  return /Loading (chunk|CSS) .*(failed|timed out)|ChunkLoadError/i.test(String(err.message || ''))
}

function promptReload(reason) {
  const now = Date.now()
  if (now - lastPromptAt < THROTTLE_MS) return
  lastPromptAt = now
  // eslint-disable-next-line no-console
  console.warn('[staleChunkGuard] 页面资源已失效(多为系统发版), 引导刷新:', reason)
  Modal.confirm({
    title: '系统已更新，需要刷新页面',
    content: '系统发布了新版本，刷新页面后即可打开这个功能。刷新会关闭已打开的页签，正在录的单据请先保存。',
    okText: '立即刷新',
    cancelText: '稍后刷新',
    onOk() {
      window.location.reload()
    }
  })
}

export function installStaleChunkGuard(router) {
  if (!router) return

  router.onError((err) => {
    if (isChunkLoadError(err)) promptReload(err && err.message)
  })

  // capture=true 才能收到不冒泡的资源加载失败事件(event.target 是 script/link 标签)
  window.addEventListener('error', (event) => {
    const tgt = event && event.target
    if (tgt && tgt.tagName) {
      const url = tgt.src || tgt.href || ''
      if ((tgt.tagName === 'SCRIPT' || tgt.tagName === 'LINK') && CHUNK_URL_RE.test(url)) {
        promptReload('资源加载失败: ' + url)
      }
      return
    }
    if (
      event && event.filename &&
      CHUNK_URL_RE.test(event.filename) &&
      SYNTAX_ERR_RE.test(event.message || '')
    ) {
      promptReload('脚本语法错: ' + event.filename)
    }
  }, true)
}
